<template>
  <HamburgerDrawer
    v-model="drawer"
    v-model:isDarkTheme="isDarkTheme"
    @select-profile="selectProfile"
    @logout="doLogout"
  />
  <!-- AppBar -->
  <v-app-bar app color="background" flat>
    <v-row class="container-navbar">
      <v-col
        :cols="mobileCols[0]"
        md="4"
        lg="3"
        class="d-flex align-center justify-start"
      >
        <router-link :to="logoLink">
          <img
            class="img-navbar"
            :src="setHeaderLogo"
            alt="Maker Market Logo"
            style="max-height: 50px; max-width: 120px; object-fit: contain"
            :style="isMobile ? { marginTop: '5px', height: '40px' } : {}"
          />
        </router-link>
        <v-divider v-if="!user?.id && !isMobile" vertical class="ma-3" />
        <v-btn
          v-if="!user?.id && !isMobile"
          class="mr-4 ml-2"
          color="secondary"
          :theme="currentTheme"
          variant="outlined"
          tag="router-link"
          target="_blank"
          href="https://lab.makermarket.com"
        >
          LABORATÓRIO
        </v-btn>
      </v-col>
      <v-col :cols="mobileCols[1]" md="4" lg="6" class="d-flex align-center">
        <v-text-field
          v-model="search"
          :placeholder="isMobile ? 'Busque aqui...' : 'Busque no Maker Market'"
          class="search-bar"
          variant="outlined"
          density="compact"
          single-line
          hide-details
          clearable
          append-inner-icon="mdi-magnify"
          @click:clear="onSearch"
          @click:append-inner="onSearch"
          @keyup.enter="onSearch"
        />
      </v-col>
      <v-col
        id="menu"
        :cols="mobileCols[2]"
        md="4"
        lg="3"
        class="d-flex align-center justify-end"
      >
        <div v-if="user?.id">
          <div v-if="isMobile">
            <v-btn icon class="mr-1" @click="$router.push('/checkout')">
              <v-badge
                :content="$store.getters['cart/quantityTotal']"
                color="primary"
                :size="isMobile ? 'large' : 'x-large'"
              >
                <v-icon
                  :color="currentTheme === 'dark' ? 'primary' : 'black'"
                  :size="isMobile ? 'large' : 'x-large'"
                >
                  mdi-cart-outline
                </v-icon>
              </v-badge>
            </v-btn>

            <!-- Ícone do menu (mobile) -->
            <v-btn icon @click="drawer = true">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </div>

          <div v-else class="d-flex align-center gap-6 justify-end">
            <v-menu offset-y transition="slide-y-transition" rounded>
              <template #activator="{ props }">
                <router-link
                  to="/conta/editar"
                  class="mr-4 text-subtitle-2 mm-profile"
                >
                  <v-avatar :image="avatarSrc" size="40" class="mr-3" />
                  <span>{{ user.firstName }}</span>
                </router-link>
                <v-btn v-bind="props" color="secondary" variant="flat">
                  {{ activeProfile }}
                  <v-icon end class="ml-1">mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="selectProfile('Maker')">
                  <v-list-item-title>Maker</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectProfile('Designer')">
                  <v-list-item-title>Designer</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectProfile('Lojista')">
                  <v-list-item-title>Lojista</v-list-item-title>
                </v-list-item>
                <v-divider class="my-2" />
                <v-list-item @click="toggleTheme" class="d-flex align-end">
                  <v-list-item-title>
                    <v-icon>
                      {{
                        isDarkTheme
                          ? "mdi-lightbulb-off-outline"
                          : "mdi-lightbulb-on-outline"
                      }}
                    </v-icon>
                    Alternar
                  </v-list-item-title>
                </v-list-item>
                <v-divider class="my-2" />
                <v-list-item @click="doLogout">
                  <div class="d-flex align-center">
                    <v-icon color="red" class="mr-2">mdi-logout</v-icon>
                    <v-list-item-title>Sair</v-list-item-title>
                  </div>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-spacer vertical class="mx-2" />

            <div
              style="position: relative; cursor: pointer"
              class="mx-2"
              @click="$router.push('/checkout')"
            >
              <v-hover v-slot="{ isHovering, props }">
                <v-badge
                  :content="$store.getters['cart/quantityTotal']"
                  color="primary"
                  bordered
                >
                  <div
                    v-bind="props"
                    class="d-inline-flex align-center justify-center cart-icon-wrapper"
                  >
                    <v-scale-transition mode="out-in">
                      <v-icon
                        :key="isHovering"
                        :color="currentTheme === 'dark' ? 'primary' : 'black'"
                        size="x-large"
                        class="transition-fast"
                      >
                        {{ isHovering ? "mdi-cart" : "mdi-cart-outline" }}
                      </v-icon>
                    </v-scale-transition>
                  </div>
                </v-badge>
              </v-hover>

              <transition-group
                name="fade"
                tag="div"
                class="popup-container-fixed"
              >
                <div
                  v-for="popup in cartPopups"
                  :key="popup.id"
                  color="confirm"
                  :class="[
                    'cart-popup-fixed',
                    popup.type === 'remove' ? 'bg-reject' : 'bg-confirm',
                  ]"
                >
                  <v-icon class="mr-2" size="small">
                    {{
                      popup.type === "remove"
                        ? "mdi-trash-can-outline"
                        : "mdi-check"
                    }}
                  </v-icon>
                  {{ popup.message }}
                </div>
              </transition-group>
            </div>
          </div>
        </div>

        <div v-else>
          <v-btn v-if="isMobile" icon @click="drawer = true">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <div v-else class="d-flex align-center">
            <v-btn
              class="mr-2"
              color="primary"
              variant="flat"
              tag="router-link"
              :to="{ path: '/catalogo' }"
            >
              Catálogo
            </v-btn>
            <v-btn
              class="mr-4 ml-2"
              color="secondary"
              :theme="currentTheme"
              variant="outlined"
              tag="router-link"
              :to="{ path: '/login' }"
            >
              Entrar
            </v-btn>
            <v-icon v-if="!user?.id" @click="toggleTheme">
              {{
                isDarkTheme
                  ? "mdi-lightbulb-off-outline"
                  : "mdi-lightbulb-on-outline"
              }}
            </v-icon>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import HamburgerDrawer from "@/components/layout/Navbar/HamburguerDrawer.vue";

export default {
  name: "NavBar",
  components: {
    HamburgerDrawer,
  },
  data() {
    return {
      search: undefined,
      defaultAvatar: require("@/assets/default-avatar.png"),
      isMobile: false,
      drawer: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["activeProfile"]),
    ...mapState("cart", ["cartPopups"]),
    ...mapState(["searchQuery"]),
    currentTheme() {
      return this.$store.state.theme;
    },
    isDarkTheme: {
      get() {
        return this.$store.state.theme === "dark";
      },
      set(val) {
        this.$store.commit("setTheme", val ? "dark" : "light");
      },
    },
    logoLink() {
      return this.user && this.user.id ? "/dashboard" : "/";
    },
    avatarSrc() {
      return this.user?.imageUri || this.defaultAvatar;
    },
    setHeaderLogo() {
      if (this.isDarkTheme) {
        if (this.isMobile) {
          return require("@/assets/logo_white.png");
        } else {
          return require("@/assets/logo-beta-horizontal-circular.png");
        }
      } else {
        if (this.isMobile) {
          return require("@/assets/logo_black.svg");
        } else {
          return require("@/assets/logo-beta-horizontal-light-circular.png");
        }
      }
    },
    mobileCols() {
      if (this.user?.id) {
        return ["2", "6", "4"];
      } else {
        return ["2", "8", "2"];
      }
    },
  },
  watch: {
    "$route.fullPath"() {
      this.search = this.$route.query?.search;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setActiveProfile"]),
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      if (this.theme) {
        this.theme.global.name = this.isDarkTheme ? "dark" : "light";
      }
    },
    doLogout() {
      this.logout();
      this.$router.push("/");
    },
    selectProfile(profile) {
      if (profile === this.activeProfile) return;
      this.setActiveProfile(profile);
      this.drawer = false;
      if (this.$route.name !== "DashboardPage") {
        this.$router.push({ name: "DashboardPage" });
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 959;
    },
    onSearch() {
      this.$store.commit("search/SET_SEARCH_QUERY", this.search);
      const query = { ...this.$route.query };

      if (this.search) {
        query.search = this.search;
      } else {
        delete query.search;
      }

      if (this.$route.path.includes("catalogo")) {
        this.$router.push({ query });
      } else {
        this.$router.push({ path: "/catalogo", query });
      }
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.text-profile {
  text-transform: uppercase;
}

.img-navbar {
  margin-top: 14px;
  transition: transform 0.5s ease-in-out;
  object-fit: contain;
  max-height: 40px;
  max-width: 100px;
}

.img-navbar:hover {
  cursor: pointer;
  transform: scale(1.3);
}

.transition-fast {
  transition: opacity 150ms ease-in-out;
}

.container-navbar {
  max-width: 90vw;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 670px) {
  .img-navbar {
    margin-left: 10px;
  }

  .search-bar {
    min-width: 35vw;
  }

  .container-navbar {
    max-width: 100vw;
  }

  .v-field__input::placeholder {
    font-size: 12px;
  }

  .v-toolbar__content {
    max-width: 95vw;
    margin: auto;
  }
}

.popup-container-fixed {
  display: grid;
  position: fixed;
  top: 80px;
  right: 40px;
  gap: 8px;
  z-index: 9999;
  justify-items: end;
}

.cart-popup-fixed {
  display: inline-block;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.875rem;
  white-space: nowrap;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.mm-profile {
  color: inherit;
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase !important;
}

.mm-profile:hover {
  opacity: 0.8;
}
</style>
